import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { ConfigContext } from '@/components/ConfigProvider';
import { ChangeDataCenter } from '@/components/TopNav/components/ChangeModule';
import { getModule } from '@/hooks/useRouteScope';
import { useError } from '@/store';

import { BackHomeWithCountdown } from './403';
import { ErrorPage } from './errorPage';

const ErrStatusPage = (props: { children?: React.ReactNode; code?: string | number; desc?: string; id?: string }) => {
  const { t } = useTranslation();
  const params = useParams();
  const { clusterList } = useContext(ConfigContext);
  const { children, code: codeProp, desc: descProp = '', id = window.location.pathname } = props;
  const { error } = useError(id);
  const showDataCenterSwitcher = getModule() === 'data-center' && clusterList?.length > 1;

  const { code, desc } = useMemo(() => {
    return {
      code: codeProp || error?.status,
      desc: descProp || error?.message,
    };
  }, [error, codeProp, descProp]);

  if (params.cluster === ':cluster') {
    return (
      <ErrorPage
        title={t('components:resource.unavailable')}
        des={desc || t('cluster:no-cluster-tip')}
        img="/images/img_403.png"
      ></ErrorPage>
    );
  }

  if (code == '404') {
    return <ErrorPage title="404" des={t('components:resource.does.not.exist')} img="/images/img_404.png"></ErrorPage>;
  }
  if (code == '403') {
    // 全页 403 展示倒计时并回首页；Tab 内隔离的 403 仅保留切换器，避免整页被踢走
    const isPageLevelForbidden = id === 'global' || id === window.location.pathname;
    const dataCenterSwitcher = showDataCenterSwitcher ? <ChangeDataCenter style={{ minWidth: 220 }} /> : null;

    return (
      <ErrorPage
        title={t('components:no.permission')}
        des={t(
          showDataCenterSwitcher
            ? 'components:current.data.center.no.access.try.switching.or.contact.administrator'
            : 'components:no.access.permission.please.contact.the.administrator.to.add.permissions',
        )}
        img="/images/img_403.png"
      >
        {isPageLevelForbidden ? <BackHomeWithCountdown extra={dataCenterSwitcher} /> : dataCenterSwitcher}
      </ErrorPage>
    );
  }
  if (code == '401') {
    return <ErrorPage title="401" des={t('components:unauthorized.please.log.in.first')} img="/images/img_401.png"></ErrorPage>;
  }

  if (code == 500) {
    return <ErrorPage title={'500'} des={t('components:server.error')} img="/images/img_401.png"></ErrorPage>;
  }

  if (code == 502) {
    return <ErrorPage title={'502'} des={t('components:gateway.error')} img="/images/img_401.png"></ErrorPage>;
  }

  return children;
};

export default ErrStatusPage;
